import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../../models/plan-adoption-form-models';
import { GetAmendRsvpFormContentModel, GetRsvpPreviousValues } from '../plan-amend-helper';
import { RsvpQuestionsWizard } from './rsvp-questions-wizard';

export class RsvpAmendQuestionsWizard extends RsvpQuestionsWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendRsvpFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.RsvpAmendQuestions,
        };
    }

    getPreviousValues(): LayDcPlanFormModel {

        const previousValues = this.wizardOptions?.location?.state?.request?.values;

        if (previousValues) {
            return previousValues;
        }

        const defaultValues = this.getDefaultFormValues();
        return GetRsvpPreviousValues(this.wizardOptions?.rsvpPlanDetail, defaultValues);        
    }
}